import { Popover, Tooltip } from '@mui/material'
import React, { useEffect, useRef } from 'react'
import { SubMenuIconWrapper, SubMenuWrapper, TextLink } from '../Styles/Styles'
import { FaCompany } from '../../../Images/icon'
import useClickOutside from '../../../../hooks/useClickOutside/useClickOutside'

const permission = JSON.parse(localStorage.getItem("permissions")) || [];

const VATAuditLogs = permission.find((o) => o.slug === "vat_audit_logs") ?? {};
const companyAccess = permission.find((o) => o.slug === "manage_subsidiary") ?? {};
const assistanceRequests = permission.find((o) => o.slug === "assistance_request") ?? {};
const dealerApi = permission.find((o) => o.slug === "dealer_api") ?? {};


const SubsidiarySubMenu = () => {

    const hasReadPermissionForDealer = companyAccess?.permissions?.find((o) => o.slug === "read")
    const hasReadPermissionForVATLogs = VATAuditLogs?.permissions?.find((o) => o.slug === "read")
    const hasReadPermissionForAssistanceRequests = assistanceRequests?.permissions?.find((o) => o.slug === "read")
    const hasReadPermissionForDealerApi = dealerApi?.permissions?.find((o) => o.slug === "read")

    const popoverRef = useRef(null);
    const isOutsideClicked = useClickOutside(popoverRef);

    const [anchorEl, setAnchorEl] = React.useState(null);

    useEffect(() => {
        if (isOutsideClicked) {
            handleClose();
        }
    }, [isOutsideClicked])

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    if (!hasReadPermissionForDealer && !hasReadPermissionForVATLogs && !hasReadPermissionForAssistanceRequests && !hasReadPermissionForDealerApi) {
        return null
    }


    return (
        <>
            <Tooltip title='Dealers' placement="right">
                <SubMenuIconWrapper
                    onClick={handleClick}
                >
                    <FaCompany />
                </SubMenuIconWrapper>
            </Tooltip>
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'center',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'center',
                    horizontal: 'left',
                }}
                ref={popoverRef}
            >
                <SubMenuWrapper>
                    {hasReadPermissionForDealer &&
                        <TextLink to="/companies" onClick={handleClose}>
                            Dealer
                        </TextLink>
                    }
                    {hasReadPermissionForDealerApi &&
                        <TextLink to="/dealer-api" onClick={handleClose}>
                            Dealer API
                        </TextLink>
                    }
                    {hasReadPermissionForVATLogs &&
                        <TextLink to="/vat-audit-logs" onClick={handleClose}>
                            VAT Audit Logs
                        </TextLink>
                    }
                    {hasReadPermissionForAssistanceRequests &&
                        <TextLink to="/assistance-requests" onClick={handleClose}>
                            Assistance Requests
                        </TextLink>
                    }
                </SubMenuWrapper>
            </Popover>
        </>
    )
}

export default SubsidiarySubMenu